var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardSelectboxCloseIconNormal = function SvgNewcsDashboardSelectboxCloseIconNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_selectbox_close_icon_normal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M193 582h16v16h-16z",
    "data-name": "\\u77E9\\u5F62 348"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_selectbox_close_icon_normal_svg__a)",
    transform: "translate(-193 -582)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#807997",
    d: "M201 598a8.01 8.01 0 0 1-8-8 8.01 8.01 0 0 1 8-8 8.01 8.01 0 0 1 8 8 8.01 8.01 0 0 1-8 8m-.027-6.795 2.49 2.531a.86.86 0 0 0 .619.259.86.86 0 0 0 .608-.249.87.87 0 0 0 .011-1.227l-2.492-2.531 2.528-2.487a.86.86 0 0 0 .259-.612.86.86 0 0 0-.249-.615.86.86 0 0 0-.618-.259.86.86 0 0 0-.607.249l-2.529 2.487-2.453-2.493a.86.86 0 0 0-.618-.259.86.86 0 0 0-.608.248.87.87 0 0 0-.011 1.227l2.453 2.494-2.5 2.456a.87.87 0 0 0-.01 1.227.86.86 0 0 0 .618.259.86.86 0 0 0 .609-.249z",
    "data-name": "\\u51CF\\u53BB 8"
  }))));
};
export default SvgNewcsDashboardSelectboxCloseIconNormal;